import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useStyles } from "../styles";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const LandingBanner: React.FC = () => {
  const styles = useStyles();
  const theme = useTheme();
  const matchDownMd = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Box sx={styles.bannerContainer}>
      <Grid container spacing={2} direction="row">
        <Grid item xs={12} sx={styles.bannerTextContainer}>
          <Typography variant="h3" sx={styles.bannerText}>
            Construction & Demolition Waste Management Portal, Thane
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LandingBanner;
